import { APP_STYLE_CONFIG } from '@/constants';
import { CARD_LABELS } from '@/constants/labels';
import { Card, ICardAction } from '@/components/Cards';

/** Props for the NextRoleplayCard component */
interface NextRoleplayCardProps {
  /** The title of the card */
  cardTitle?: string;
  /** The title of the next simulation */
  nextSimulationTitle?: string;
  /** Actions available for the next roleplay */
  nextRoleplayActions: ICardAction[];
  /** Whether to show a border around the card */
  showCardBorder?: boolean;
  /** Whether to show a border around the card content */
  showCardContentBorder?: boolean;
}

/**
 * Component for displaying a card that allows users to view the next roleplay simulation.
 * It shows the title of the next simulation and provides actions for the next roleplay.
 */
export const NextRoleplayCard: React.FC<NextRoleplayCardProps> = ({
  cardTitle = CARD_LABELS.NEXT_ROLEPLAY,
  nextSimulationTitle,
  nextRoleplayActions,
  showCardBorder = APP_STYLE_CONFIG.showCardBorder,
  showCardContentBorder = APP_STYLE_CONFIG.showCardContentBorder,
}) => {
  return (
    <Card
      actions={nextRoleplayActions}
      subtitle={nextSimulationTitle}
      title={cardTitle}
      withBorder={showCardBorder}
      withContentBorder={showCardContentBorder}
    />
  );
};

NextRoleplayCard.displayName = 'NextRoleplayCard';

export default NextRoleplayCard;
